import useFieldState from "../../../hooks/useFieldState";
import useForm from "../../../hooks/useForm";
import { useWizard } from "../../../hooks/useWizard";
import { DropdownInput } from "../../Form/DropdownInput";
import {
  ModalContentContainer,
  ModalBody,
  ModalSection,
  ModalFooter,
} from "../../Modal/index";

export const MetricSelector = () => {
  const [{ pollutant_metric_list }] = useFieldState();
  const { register, setValue, getSelectedQueryLayer } = useForm();
  const { formValues, skip, error } = useWizard();

  return (
    <ModalContentContainer>
      <ModalBody
        title="Which pollutant metric are you interested in?"
        customStyle=""
      >
        <ModalSection styles="h-full pt-2">
          There are 21 pollutant metrics to choose from, covering those stated in
          the Air Quality Standards Regulations.
          <div className="text-sm sm:text-base py-5">
            Individual data sets for each of the data sources that make up the
            compliance assessment are also available. <br/> These are listed below -
            availability of each is dependent on what metric is selected.
            <ul className="text-xs sm:text-base space-y-1 list-disc px-8 pt-5 list-outside">
              <li>
                Fixed measurements - Measurements from UK AIR quality monitoring
                networks including Defra's Automatic Urban Rural Network (AURN).
                Note that fixed monitoring stations in the national networks
                used for the compliance assessment are distributed according to
                air quality zones and some Local Authorities will not include
                these measurements points.
              </li>
              <li>
                Supplementary measurements – Measurements from the UK Urban NO<sub>2</sub> Network. A diffusion tube network (only visible in some
                locations when Nitrogen Dioxide annual mean is selected).
              </li>
              <li>
                Modelled Roadside Concentrations - Roadside concentrations
                modelled by Defra's Pollution Climate Mapping Models.
              </li>
              <li>
                Modelled Background Concentrations - 1x1km background
                concentrations modelled by Defra's Pollution Climate Mapping
                Models.
              </li>
            </ul>
          </div>
        </ModalSection>
        <ModalSection styles="flex content-center flex-wrap">
          <DropdownInput
            displayError={error}
            errorMessage="Please select the pollutant metric."
            label="Select the pollutant metric"
            name="pollutant_metric"
            options={pollutant_metric_list[getSelectedQueryLayer]?.map(
              (pm) => ({ value: pm.id, label: pm.name })
            )}
            ref={register}
            styles={{
              container: "w-full sm:w-2/3",
              label: "text-sm sm:text-3xl font-bold",
              dropdown: "mt-2 max-w-xs",
              error: "text-red-600 font-xs h-5"
            }}
            setValue={setValue}
          />
        </ModalSection>
      </ModalBody>
      <ModalFooter
        currentFormValue="pollutant_metric"
        submitButtonLabel="Show details and get data"
        submit={() => {
          const key = Object.getOwnPropertyNames(formValues)[0];

          setValue(key, formValues[key]);
          skip();
        }}
      />
    </ModalContentContainer>
  );
};
